/* ============================================================
   Magic Pearl - Karten-Interaktionen
   ------------------------------------------------------------
   1. Das Herz. Merkt Produkte im Browser des Besuchers.
   2. Der Add-Knopf. Ein Klick, wenn es nichts zu waehlen gibt.
      Sonst fragt eine Flaeche im Bildfeld nach - und zwar
      Option fuer Option, nicht alle Varianten auf einmal.
   3. Die Favoritenseite.

   Warum Option fuer Option: ein Produkt mit acht Farben und
   zwei Metallen hat sechzehn Varianten. Sechzehn Knoepfe
   nebeneinander helfen niemandem. Acht Farben und danach zwei
   Metalle sind zwei ruhige Entscheidungen. Beim Waehlen der
   Farbe wechselt ausserdem das Bild, damit man sieht, worueber
   man gerade entscheidet.

   Warenkorb-Anbindung nach dem in custom.js dokumentierten Weg.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'mp:favs';
  var tv = window.themeVariables || {};
  var routes = tv.routes || {};
  var einstellungen = tv.settings || {};
  var cartAdd = (routes.cartAddUrl || '/cart/add') + '.js';
  var cartGet = (routes.cartUrl || '/cart') + '.js';

  function ruhig() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* =========================================================
     Favoriten
     ========================================================= */
  var Fav = {
    read: function () {
      try {
        var v = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string'; }) : [];
      } catch (e) { return []; }
    },
    write: function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 200))); } catch (e) {}
      document.documentElement.dispatchEvent(new CustomEvent('mp:favs', {
        bubbles: true, detail: { list: list }
      }));
    },
    has: function (h) { return this.read().indexOf(h) > -1; },
    toggle: function (h) {
      var l = this.read(), i = l.indexOf(h);
      if (i > -1) { l.splice(i, 1); } else { l.unshift(h); }
      this.write(l);
      return i === -1;
    }
  };
  window.MagicPearlFavs = Fav;

  function favSync() {
    var list = Fav.read();
    Array.prototype.forEach.call(document.querySelectorAll('.mp-fav'), function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(document.querySelectorAll('mp-fav-count'), function (c) {
      c.textContent = list.length;
      if (list.length) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
    });
  }

  /* ---------------------------------------------------------
     Klaviyo

     Das Ereignis liegt danach auf Klaviyos Servern, nicht im
     Browser. Loescht Safari die lokale Liste nach sieben Tagen,
     weiss Klaviyo trotzdem noch, was jemand wollte - die
     Erinnerungsmail geht auch dann noch raus.
     --------------------------------------------------------- */
  var konfig = window.mpFavKonfig || {};

  function klaviyo(name, b) {
    var q = window._learnq;
    if (!q || !b) return;
    try {
      if (konfig.email) q.push(['identify', { '$email': konfig.email }]);
      q.push(['track', name, {
        ProductName: b.getAttribute('data-titel') || '',
        ProductID: b.getAttribute('data-produkt-id') || '',
        Handle: b.getAttribute('data-handle') || '',
        URL: b.getAttribute('data-url') || '',
        ImageURL: b.getAttribute('data-bild') || '',
        Price: parseFloat(b.getAttribute('data-preis') || '0'),
        Currency: konfig.waehrung || 'EUR'
      }]);
    } catch (e) {}
  }

  /* ---------------------------------------------------------
     Rueckmeldung oben mittig

     Ein einziges Element, das wiederverwendet wird. Zweimal
     schnell hintereinander getippt heisst: derselbe Kasten
     bekommt neuen Text und der Zeitgeber faengt von vorn an -
     keine zwei Meldungen, die sich stapeln.
     --------------------------------------------------------- */
  var toast = null;

  /* Der Kasten wird EINMAL beim Laden angelegt, nicht beim ersten
     Klick.

     Vorher entstand er im Klick-Moment. Der Browser musste dadurch
     mitten in der Interaktion ein neues Element einhaengen, dafuer
     eine eigene Kompositionsebene bauen und - solange der Kasten
     backdrop-filter trug - den gesamten Seitenhintergrund in eine
     Textur rendern. Fuer ein bis zwei Bilder hat er dabei Dinge
     mitgezeichnet, die eigentlich ausserhalb des Fensters liegen:
     die Kopfzeile der Warenkorb-Schublade steht 500 px rechts
     neben dem Fenster und blitzte als Strichmuster oben durch,
     und die Seitenbreite sprang kurz mit.

     Existiert der Kasten von Anfang an, aendert der Klick nur noch
     eine Klasse. Kein Einhaengen, kein Ebenenbau, kein Sprung. */
  function holeToast() {
    /* isConnected mitpruefen: haengt der Kasten nicht mehr im
       Dokument - etwa weil ein Seitenwechsel den Rumpf getauscht
       hat -, wuerde die Meldung sonst still in einem abgehaengten
       Element landen und nie erscheinen. */
    if (toast && toast.isConnected) return toast;
    toast = document.createElement('div');
    toast.className = 'mp-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    /* Der innere Kasten traegt das Aussehen UND die Bewegung. Der
       aeussere haengt nur am Fenster und blendet ein - siehe die
       ausfuehrliche Begruendung in mp-interactions.liquid. */
    toast._innen = document.createElement('div');
    toast._innen.className = 'mp-toast__innen';
    toast.appendChild(toast._innen);
    document.body.appendChild(toast);
    return toast;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', holeToast);
  } else {
    holeToast();
  }

  function meldung(text, an) {
    holeToast();
    toast.classList.toggle('mp-toast--weg', !an);

    /* Das Zeichen als Markup, der Text ueber textContent.
       Getauscht wird nur der Inhalt des inneren Kastens - der
       aeussere bleibt unangetastet im Dokument stehen. */
    toast._innen.innerHTML =
      '<svg class="mp-toast__ico" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">' +
      '<path d="M12 20.8 3.9 12.7a5.2 5.2 0 0 1 7.35-7.35L12 6.1l.75-.75a5.2 5.2 0 0 1 7.35 7.35Z" ' +
      'fill="' + (an ? 'currentColor' : 'none') + '" stroke-linejoin="round"/></svg>';

    var wort = document.createElement('span');
    wort.textContent = text;
    toast._innen.appendChild(wort);

    void toast.offsetWidth;
    toast.classList.add('is-da');
    clearTimeout(toast._weg);
    toast._weg = setTimeout(function () { toast.classList.remove('is-da'); }, 2200);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.mp-fav');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-handle');
    if (!h) return;
    var on = Fav.toggle(h);
    klaviyo(on ? 'Zur Wunschliste hinzugefügt' : 'Von der Wunschliste entfernt', b);
    meldung(on ? 'Zur Wunschliste hinzugefügt' : 'Von der Wunschliste entfernt', on);
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on && !ruhig()) {
      b.classList.remove('is-pop');
      void b.offsetWidth;
      b.classList.add('is-pop');
    }
  });

  document.documentElement.addEventListener('mp:favs', function () { favSync(); });

  /* =========================================================
     Die Perle, die in die Tasche wandert
     ========================================================= */
  function perleFliegen(von) {
    if (ruhig()) return;
    /* Bewusst cart-count: das Herz in der Kopfzeile traegt
       dieselbe Blasen-Klasse wie der Warenkorbzaehler. */
    var ziel = document.querySelector('cart-count') ||
               document.querySelector('[aria-controls="mini-cart"]');
    if (!ziel || !von) return;
    var a = von.getBoundingClientRect(), b = ziel.getBoundingClientRect();
    if (!a.width || !b.width) return;

    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);

    var bahn = document.createElement('span');
    bahn.className = 'mp-fly';
    bahn.style.left = (a.left + a.width / 2) + 'px';
    bahn.style.top = (a.top + a.height / 2) + 'px';
    var kern = document.createElement('span');
    kern.className = 'mp-fly__kern';
    bahn.appendChild(kern);
    document.body.appendChild(bahn);

    void bahn.offsetWidth;
    bahn.style.transform = 'translateX(' + dx + 'px)';
    kern.style.transform = 'translateY(' + dy + 'px) scale(.35)';
    kern.style.opacity = '.2';
    setTimeout(function () { bahn.remove(); }, 760);

    ziel.classList.remove('is-bump');
    void ziel.offsetWidth;
    ziel.classList.add('is-bump');
  }

  /* =========================================================
     Warenkorb
     ========================================================= */
  function inDenKorb(id) {
    return fetch(cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (j) {
          throw new Error(j.description || j.message || 'Fehler');
        });
      }
      return r.json();
    }).then(function () {
      return fetch(cartGet, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      var root = document.documentElement;
      root.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: { id: id } } }));
      root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      /* openMiniCart zieht Focals Schublade auf - so, wie es
         das Theme bei seinem eigenen Kaufknopf auch tut. */
      root.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart, openMiniCart: einstellungen.cartType === 'drawer' }
      }));
      return cart;
    });
  }

  function zustand(qa, name) {
    qa.setAttribute('data-state', name);
    var btn = qa.querySelector('.mp-qa__btn');
    if (btn) btn.disabled = (name === 'laedt');
  }

  function erledigt(qa, von) {
    zustand(qa, 'drin');
    perleFliegen(von || qa);
    clearTimeout(qa._zurueck);
    qa._zurueck = setTimeout(function () { zustand(qa, 'bereit'); }, 1900);
  }

  function fehler(qa, text) {
    zustand(qa, 'fehler');
    qa.setAttribute('title', text || '');
    clearTimeout(qa._zurueck);
    qa._zurueck = setTimeout(function () {
      zustand(qa, 'bereit');
      qa.removeAttribute('title');
    }, 2600);
  }

  function daten(qa) {
    var leer = { opts: [], vars: [], bild: {}, sw: [] };
    var s = qa.querySelector('script.mp-qa__data');
    if (!s) return leer;
    try {
      var d = JSON.parse(s.textContent);
      return { opts: d.opts || [], vars: d.vars || [], bild: d.bild || {}, sw: d.sw || [] };
    } catch (e) { return leer; }
  }

  /* =========================================================
     Bild der Karte auf eine Variante stellen
     ========================================================= */
  function bildStellen(karte, mediaId, adresse) {
    if (!karte) return;
    /* Ab jetzt zeigt die Karte ein bewusst gewaehltes Bild. Die
       Galerie faehrt auf das erste Dia zurueck - dort sitzt das
       Variantenbild - und blaettert nicht mehr von selbst. */
    karte.classList.add('mp-bild-fix');
    var spurZurueck = karte.querySelector('[data-spur]');
    if (spurZurueck) spurZurueck.scrollLeft = 0;

    /* Weg 1: die Karte bringt versteckte Variantenbilder mit.
       Das ist der saubere Fall - nichts wird nachgeladen. */
    var bilder = karte.querySelectorAll('img[data-media-id]');
    if (mediaId && bilder.length > 1) {
      var treffer = false;
      Array.prototype.forEach.call(bilder, function (b) {
        if (String(b.getAttribute('data-media-id')) === String(mediaId)) treffer = true;
      });
      if (treffer) {
        Array.prototype.forEach.call(bilder, function (b) {
          var ist = String(b.getAttribute('data-media-id')) === String(mediaId);
          if (ist) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
        });
        return;
      }
    }

    /* Weg 2: kein passendes Bild in der Karte - dann die Adresse
       aus dem Datenblock setzen. Betrifft alle Produkte, deren
       erste Option nicht "Farbe" heisst. */
    if (!adresse) return;
    var sichtbar = karte.querySelector('.pearl-item__img:not([hidden])');
    if (!sichtbar || sichtbar.getAttribute('src') === adresse) return;
    sichtbar.removeAttribute('srcset');
    sichtbar.removeAttribute('sizes');
    sichtbar.setAttribute('src', adresse);
  }

  function swatchMarkieren(karte, wert) {
    if (!karte || !wert) return;
    var sw = karte.querySelectorAll('.pearl-swatch');
    Array.prototype.forEach.call(sw, function (s) {
      var ist = (s.getAttribute('aria-label') || '') === wert;
      if (ist) { s.setAttribute('aria-current', 'true'); }
      else { s.removeAttribute('aria-current'); }
    });
  }

  /* =========================================================
     Auswahlflaeche - eine Option nach der anderen
     ========================================================= */
  function blattSchliessen(karte) {
    var b = karte && karte.querySelector('.mp-sheet');
    if (!b) return;

    /* Reihenfolge beim Zufahren - das war vorher verkehrt.

       Die Klasse fuer "Kartenreihe ausgeblendet" fiel sofort, die
       Flaeche fuhr aber noch 420 ms nach unten. Fuer diese knappe
       halbe Sekunde standen beide Reihen gleichzeitig da, und die
       Kreise auf der Karte erschienen hart, ohne Uebergang.

       Jetzt faehrt die Flaeche erst weg, und die Reihe kommt danach
       zurueck - mit dem Deckkraft-Uebergang, den sie im Stylesheet
       ohnehin hat. Dieselbe Zeit wie die Fahrt (420 ms), plus ein
       Wimpernschlag Reserve.

       Beides haengt an einem einzigen Zeitgeber. Zwei getrennte waren
       ein Denkfehler: der spaetere raeumte die Flaeche, der fruehere
       fragte vorher "liegt hier noch eine Flaeche?" - und bekam
       natuerlich ja zu hoeren, weil die Raeumung erst danach kam. Die
       Reihe blieb dadurch fuer immer verborgen. Jetzt wird erst
       geraeumt und in derselben Runde geprueft. */
    b.classList.remove('is-auf');
    setTimeout(function () {
      if (b.parentNode) b.remove();
      /* Nur, wenn in der Zwischenzeit nicht schon wieder eine Flaeche
         aufgemacht wurde - sonst holt dieser Rueckruf die Reihe unter
         der neuen Flaeche hervor. */
      if (!karte.querySelector('.mp-sheet')) karte.classList.remove('mp-blende-farben');
    }, 440);
    karte.classList.remove('mp-hat-blatt');
  }

  function werteVon(vars, i) {
    var raus = [];
    vars.forEach(function (v) {
      if (v.o[i] != null && raus.indexOf(v.o[i]) === -1) raus.push(v.o[i]);
    });
    return raus;
  }

  function blattOeffnen(qa) {
    var karte = qa.closest('.pearl-item');
    var feld = karte && karte.querySelector('.pearl-item__media');
    if (!feld) return;

    Array.prototype.forEach.call(document.querySelectorAll('.pearl-item.mp-hat-blatt'), function (k) {
      if (k !== karte) blattSchliessen(k);
    });
    if (karte.querySelector('.mp-sheet')) { blattSchliessen(karte); return; }

    var d = daten(qa);
    var wahl = [];
    var manuell = [];   /* was der Besucher selbst getippt hat - nur das laesst sich zurueckgehen */

    /* Optionen mit nur einem Wert brauchen keine Frage. */
    d.opts.forEach(function (n, i) {
      if (werteVon(d.vars, i).length === 1) wahl[i] = werteVon(d.vars, i)[0];
    });

    /* Hat der Besucher auf der Karte schon eine Farbe getippt,
       gilt sie - danach wird nicht noch einmal gefragt. */
    var aktiv = karte.querySelector('.pearl-swatch[aria-current="true"]');
    if (aktiv) {
      var name = aktiv.getAttribute('aria-label');
      d.opts.forEach(function (n, i) {
        if (wahl[i] == null && werteVon(d.vars, i).indexOf(name) > -1) wahl[i] = name;
      });
    }

    var blatt = document.createElement('div');
    blatt.className = 'mp-sheet';
    blatt.setAttribute('role', 'group');
    feld.appendChild(blatt);
    karte.classList.add('mp-hat-blatt');
    void blatt.offsetWidth;
    blatt.classList.add('is-auf');

    function offen() {
      for (var i = 0; i < d.opts.length; i++) { if (wahl[i] == null) return i; }
      return -1;
    }

    function passt(i, wert) {
      return d.vars.filter(function (v) {
        if (v.o[i] !== wert) return false;
        for (var k = 0; k < d.opts.length; k++) {
          if (k !== i && wahl[k] != null && v.o[k] !== wahl[k]) return false;
        }
        return true;
      });
    }

    function treffer() {
      return d.vars.filter(function (v) {
        for (var k = 0; k < d.opts.length; k++) {
          if (wahl[k] != null && v.o[k] !== wahl[k]) return false;
        }
        return true;
      })[0];
    }

    function absenden() {
      var v = treffer();
      if (!v || !v.a) { blattSchliessen(karte); fehler(qa, 'Diese Zusammenstellung ist nicht verfügbar'); return; }
      zustand(qa, 'laedt');
      inDenKorb(v.id).then(function () {
        blattSchliessen(karte);
        erledigt(qa, qa);
      }).catch(function (err) {
        blattSchliessen(karte);
        fehler(qa, err && err.message);
      });
    }

    /* Zeigt die Karte dieselben Kreise schon selbst?

       Unter dem Bild steht bei vielen Produkten die Farbreihe. Fragt
       die Auswahlflaeche dann nach der Farbe, stehen dieselben Kreise
       zweimal untereinander - und keiner der beiden ist offensichtlich
       der richtige.

       Erster Versuch war, die Flaeche nach unten zeigen zu lassen
       ("Farbe unten waehlen" mit Pfeil und Ring um die Kartenreihe).
       Hat Max nicht gefallen - zu Recht: Es verlangt vom Besucher,
       einer Anweisung zu folgen, statt einfach zu tippen, was vor ihm
       liegt.

       Jetzt umgekehrt: Die Flaeche fragt wie immer selbst, und die
       Reihe auf der Karte tritt fuer diesen Moment ab. Sichtbar ist
       dann genau eine Reihe - die, die gerade dran ist.

       Geprueft wird nur noch, OB die Karte fuer diese Option
       ueberhaupt Kreise zeigt - nicht, ob sie alle zeigt.

       Erst hatte ich verlangt, dass die Kartenreihe vollstaendig ist:
       Bei "+18" zeige sie nur einen Ausschnitt, sei also etwas
       anderes als die Flaeche und duerfe bleiben. In der Praxis ist
       das falsch. Genau dort stehen die meisten Kreise doppelt - fuenf
       auf der Karte, alle einundzwanzig in der Flaeche -, und die
       fuenf beantworten dieselbe Frage. Sie treten also auch dort ab.

       Es bleibt bei der ersten Option: Die Kartenreihe kennt nur die
       Farbe. */
    function karteBietet(i) {
      if (i !== 0) return null;
      var reihe = karte.querySelector('.pearl-swatches');
      if (!reihe) return null;
      if (!reihe.querySelector('.pearl-swatch')) return null;
      return reihe;
    }

    function zeichne() {
      var i = offen();
      karte.classList.remove('mp-blende-farben');
      if (i === -1) { absenden(); return; }

      var werte = werteVon(d.vars, i);
      var kopf = '<div class="mp-sheet__kopf"><span>' + d.opts[i] +
        (d.opts.length > 1 ? ' <em>' + (i + 1) + '/' + d.opts.length + '</em>' : '') +
        ' <b class="mp-sheet__wert"></b>' +
        '</span><span class="mp-sheet__ecke">' +
        (manuell.length ? '<button type="button" class="mp-sheet__rueck" aria-label="Zurück"><svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M10 2 4 8l6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' : '') +
        '<button type="button" class="mp-sheet__zu" aria-label="Schließen"><svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>' +
        '</span></div>';

      /* Flaechen statt Namen - aber nur, wenn es fuer diese Option
         wirklich Flaechen gibt.

         Gepruefte Bedingung: mindestens die Haelfte der Werte hat eine
         hinterlegte Farbe. Sonst stuende neben acht Kreisen ein
         einzelner leerer, und ein leerer Kreis ist schlimmer als ein
         Wort. Optionen wie "Laenge" oder "Groesse" bleiben damit
         automatisch Text - dort gibt es nichts zu zeigen. */
      var flaechen = (d.sw && d.sw[i]) || {};
      var mitFlaeche = werte.filter(function (w) { return flaechen[w]; }).length;
      var alsFlaeche = werte.length > 0 && mitFlaeche >= Math.ceil(werte.length / 2);

      var reihe = werte.map(function (w) {
        var moeglich = passt(i, w).some(function (v) { return v.a; });
        var attr = (moeglich ? '' : ' disabled') + ' data-i="' + i + '" data-wert="' +
          String(w).replace(/"/g, '&quot;') + '"';

        if (alsFlaeche) {
          /* title fuer die Maus, aria-label fuer den Screenreader, und
             der Name erscheint zusaetzlich oben in der Kopfzeile, sobald
             man auf einer Flaeche steht - eine Farbe ohne lesbaren Namen
             waere sonst ein Raten. */
          var stil = flaechen[w] || '';
          return '<button type="button" class="mp-sheet__sw' + (moeglich ? '' : ' is-weg') + '"' +
            attr + ' title="' + String(w).replace(/"/g, '&quot;') + '"' +
            ' aria-label="' + String(w).replace(/"/g, '&quot;') + '"' +
            ' style="' + stil.replace(/"/g, '&quot;') + '"></button>';
        }

        return '<button type="button" class="mp-sheet__opt' + (moeglich ? '' : ' is-weg') + '"' +
          attr + '>' + w + '</button>';
      }).join('');

      blatt.innerHTML = kopf +
        '<div class="mp-sheet__reihe' + (alsFlaeche ? ' mp-sheet__reihe--sw' : '') + '">' + reihe + '</div>';

      /* Dopplung vermeiden: Zeigt die Karte dieselbe Reihe, tritt sie
         ab, solange die Flaeche fragt. Der Platz bleibt stehen - die
         Reihe wird nur unsichtbar. Wuerde sie ganz verschwinden,
         ruckte die halbe Kachelreihe daneben mit hoch. */
      if (karteBietet(i)) karte.classList.add('mp-blende-farben');

      /* Den Namen der Flaeche, auf der man steht, oben anzeigen. */
      var anzeige = blatt.querySelector('.mp-sheet__wert');
      if (anzeige && alsFlaeche) {
        var zeigeName = function (ev) {
          var t = ev.target.closest('.mp-sheet__sw');
          anzeige.textContent = t ? (t.getAttribute('aria-label') || '') : '';
        };
        blatt.addEventListener('pointerover', zeigeName);
        blatt.addEventListener('focusin', zeigeName);
        blatt.addEventListener('pointerleave', function () { anzeige.textContent = ''; });
      }

      var erste = blatt.querySelector('.mp-sheet__sw:not([disabled]), .mp-sheet__opt:not([disabled])');
      if (erste) erste.focus({ preventScroll: true });
    }

    blatt.addEventListener('click', function (ev) {
      ev.stopPropagation();
      if (ev.target.closest('.mp-sheet__zu')) { blattSchliessen(karte); return; }
      if (ev.target.closest('.mp-sheet__rueck')) {
        var letzte = manuell.pop();
        if (letzte != null) wahl[letzte] = null;
        zeichne();
        return;
      }
      var o = ev.target.closest('.mp-sheet__opt, .mp-sheet__sw');
      if (!o || o.disabled) return;

      var i = parseInt(o.getAttribute('data-i'), 10);
      wahl[i] = o.getAttribute('data-wert');
      manuell.push(i);

      /* Bild auf die getroffene Wahl stellen, damit man sieht,
         worueber man gerade entscheidet. */
      var v = passt(i, wahl[i]).filter(function (x) { return x.a; })[0] || passt(i, wahl[i])[0];
      bildStellen(karte, v && v.m, i === 0 ? d.bild[wahl[i]] : null);
      swatchMarkieren(karte, wahl[i]);

      zeichne();
    });

    zeichne();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mp-qa__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var qa = btn.closest('mp-quick-add');
    if (!qa || qa.getAttribute('data-state') === 'laedt') return;

    var d = daten(qa);
    if (!d.vars.some(function (v) { return v.a; })) return;

    if (d.vars.length === 1) {
      zustand(qa, 'laedt');
      inDenKorb(d.vars[0].id)
        .then(function () { erledigt(qa, btn); })
        .catch(function (err) { fehler(qa, err && err.message); });
      return;
    }
    blattOeffnen(qa);
  });

  /* Klick daneben und Escape schliessen die Auswahl. Der Knopf
     selbst ist ausgenommen: beide Zuhoerer haengen am Dokument,
     ohne die Ausnahme fiele die Auswahl im selben Klick wieder zu. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.mp-sheet')) return;
    if (e.target.closest('mp-quick-add')) return;

    Array.prototype.forEach.call(document.querySelectorAll('.pearl-item.mp-hat-blatt'), blattSchliessen);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Array.prototype.forEach.call(document.querySelectorAll('.pearl-item.mp-hat-blatt'), blattSchliessen);
  });

  /* =========================================================
     Bildergalerie auf der Karte

     Das Wischen macht der Browser (scroll-snap). Hier laufen nur
     die zwei Dinge, die er nicht kann: die Punkte nachfuehren und
     die Pfeile bedienen. Geblaettert wird ausschliesslich auf
     Zuruf - kein Bildwechsel, nur weil der Zeiger vorbeikommt.
     ========================================================= */
  /* Der Klon.

     Endlos wischen heisst: Nach dem letzten Bild kommt wieder das
     erste, ohne zurueckzuwischen. Ein Rollbereich kann aber nicht
     ueber sein Ende hinaus - dort ist einfach nichts mehr, und die
     Geste verpufft.

     Also bekommt die Spur hinten eine Kopie des ersten Dias. Wer
     weiterwischt, landet darauf; sobald die Bewegung steht, setzen
     wir die Spur lautlos auf Null zurueck. Weil dort dasselbe Bild
     steht, ist der Sprung unsichtbar.

     Die Kopie traegt dieselben data-media-id wie das Original -
     der Bildwechsel beim Farbklick greift damit automatisch auch
     auf ihr, ohne dass hier etwas nachgezogen werden muss. */
  function klonSetzen(karte) {
    if (!karte) return;
    var spur = karte.querySelector('[data-spur]');
    if (!spur || spur.querySelector('[data-klon]')) return;
    var dias = spur.querySelectorAll('.pearl-item__dia');
    if (dias.length < 2) return;
    var klon = dias[0].cloneNode(true);
    klon.setAttribute('data-klon', '');
    klon.setAttribute('aria-hidden', 'true');
    spur.appendChild(klon);
  }

  function echteDias(spur) {
    return spur.querySelectorAll('.pearl-item__dia:not([data-klon])').length;
  }

  function punkteSetzen(karte) {
    if (!karte) return;
    var spur = karte.querySelector('[data-spur]');
    var punkte = karte.querySelector('[data-punkte]');
    if (!spur || !punkte) return;

    var breite = spur.clientWidth || 1;
    var i = Math.round(spur.scrollLeft / breite);
    var echt = echteDias(spur);

    /* Steht die Spur auf dem Klon, ist das in Wahrheit Bild 1 -
       erst fuer die Punkte, danach auch wirklich.

       Zwei Bedingungen, damit der Ruecksprung niemandem unter den
       Finger faehrt:
         1. Die Spur muss WIRKLICH auf dem Klon stehen (< 4 px
            daneben), nicht bloss auf dem Weg dorthin sein. Beim
            Schwung liegt sie kurz bei 3,6 - gerundet waere das
            schon der Klon.
         2. Es darf kein Finger auf der Spur liegen. Wer mitten in
            der Bewegung haengenbleibt, soll nicht plotzlich am
            Anfang stehen. Beim Loslassen wird erneut geprueft. */
    if (echt && i >= echt) {
      i = 0;
      var aufKlon = Math.abs(spur.scrollLeft - breite * echt) < 4;
      if (aufKlon && !spur._mpFinger) spurUmsetzen(spur, 0);
    }

    var alle = punkte.children;
    for (var k = 0; k < alle.length; k++) {
      alle[k].classList.toggle('is-hier', k === i);
    }

    /* Keine abgeschalteten Pfeile mehr: In einer Runde ohne Anfang
       und Ende gibt es keine Richtung, die nicht weitergeht. */
    var zur = karte.querySelector('.pearl-item__pfeil--zurueck');
    var vor = karte.querySelector('.pearl-item__pfeil--vor');
    if (zur) zur.disabled = false;
    if (vor) vor.disabled = false;
  }

  /* Springen ohne Weichlauf. scroll-behavior kommt aus dem
     Stylesheet und wuerde den Ruecksprung als sichtbare Fahrt durch
     alle Bilder zeigen - genau das soll niemand sehen. */
  function spurUmsetzen(spur, links) {
    if (Math.abs(spur.scrollLeft - links) < 2) return;
    var vorher = spur.style.scrollBehavior;
    spur.style.scrollBehavior = 'auto';
    spur.scrollLeft = links;
    requestAnimationFrame(function () { spur.style.scrollBehavior = vorher; });
  }

  /* Fingerwache. Solange jemand die Spur haelt, wird nicht
     umgesetzt - siehe punkteSetzen. */
  document.addEventListener('touchstart', function (e) {
    var spur = e.target.closest && e.target.closest('[data-spur]');
    if (spur) spur._mpFinger = true;
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function (e) {
    var spur = e.target.closest && e.target.closest('[data-spur]');
    if (!spur) return;
    spur._mpFinger = false;
    /* Nach dem Loslassen laeuft der Schwung noch. Zweimal nachsehen:
       einmal, wenn er ueblicherweise steht, einmal mit Reserve. */
    setTimeout(function () { punkteSetzen(spur.closest('.pearl-item')); }, 400);
    setTimeout(function () { punkteSetzen(spur.closest('.pearl-item')); }, 900);
  }, { passive: true, capture: true });

  /* scroll steigt nicht auf - deshalb in der Einfangphase lauschen */
  document.addEventListener('scroll', function (e) {
    var spur = e.target;
    if (!spur || !spur.hasAttribute || !spur.hasAttribute('data-spur')) return;
    clearTimeout(spur._punktzeit);
    spur._punktzeit = setTimeout(function () {
      punkteSetzen(spur.closest('.pearl-item'));
    }, 60);
  }, true);

  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('.pearl-item__pfeil');
    if (!p) return;
    e.preventDefault();
    e.stopPropagation();
    var karte = p.closest('.pearl-item');
    var spur = karte && karte.querySelector('[data-spur]');
    if (!spur) return;
    karte._handisch = true;

    var richtung = parseInt(p.getAttribute('data-pfeil'), 10);
    var breite = spur.clientWidth || 1;
    var i = Math.round(spur.scrollLeft / breite);
    var echt = echteDias(spur);

    if (richtung > 0) {
      /* Vorwaerts immer weiterfahren - am Ende in den Klon hinein,
         den Rest erledigt der Ruecksprung. */
      spur.scrollBy({ left: breite, behavior: 'smooth' });
    } else if (i <= 0) {
      /* Rueckwaerts vom ersten Bild: ans Ende setzen. Ohne Fahrt,
         weil eine Fahrt rueckwaerts durch alle Bilder laenger
         dauert als der Blick, der sie ausgeloest hat. */
      spurUmsetzen(spur, breite * (echt - 1));
    } else {
      spur.scrollBy({ left: -breite, behavior: 'smooth' });
    }
    /* Nicht allein auf das scroll-Ereignis verlassen: es bleibt aus,
       solange der Tab im Hintergrund liegt. Nach dem Weichlauf noch
       einmal selbst nachsehen. */
    setTimeout(function () { punkteSetzen(karte); }, 450);
  });

  function galerienSetzen() {
    Array.prototype.forEach.call(document.querySelectorAll('.pearl-item [data-punkte]'), function (p) {
      var karte = p.closest('.pearl-item');
      klonSetzen(karte);
      punkteSetzen(karte);
    });
  }

  /* =========================================================
     Favoritenseite
     ========================================================= */
  /* "Stuecke" statt "Produkte". Die Zahl steht jetzt in Handschrift
     neben der Ueberschrift, und "3 Produkte" klingt dort wie eine
     Bestandsmeldung aus dem Lager. Ein Schmuckstueck ist ein Stueck. */
  function favZaehlText(n) { return n === 1 ? '1 Stück' : n + ' Stücke'; }

  /* Eine geteilte Liste steht in der Adresse, nicht im Speicher.

     Damit braucht die Geschenkliste weder Konto noch Server: die
     Handles reisen im Link mit, die Karten holt der Empfaenger
     sich beim Oeffnen frisch vom Shop. Preise und Verfuegbarkeit
     sind dadurch immer die von heute, nicht die vom Verschicken. */
  function geteilteListe() {
    var m = location.search.match(/[?&]liste=([^&]+)/);
    if (!m) return null;
    var roh;
    try { roh = decodeURIComponent(m[1]); } catch (e) { return null; }
    var l = roh.split(',').map(function (x) { return x.trim(); })
      .filter(function (x) { return /^[a-z0-9-]{1,120}$/i.test(x); })
      .slice(0, 60);
    return l.length ? l : null;
  }

  function teilenLink() {
    var l = Fav.read().slice(0, 60);
    if (!l.length) return '';
    var basis = (konfig.seite || '/').replace(/\/$/, '');
    return location.origin + basis + '/pages/favoriten?liste=' + encodeURIComponent(l.join(','));
  }

  function favLeerPruefen(wurzel) {
    var gitter = wurzel.querySelector('[data-fav-gitter]');
    var leer = wurzel.querySelector('[data-fav-leer]');
    var voll = gitter.querySelector('.mp-favs__zelle');
    gitter.hidden = !voll;
    leer.hidden = !!voll;
  }

  function zeigen(el, ja) { if (el) { if (ja) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); } } }

  function favSeite() {
    var wurzel = document.querySelector('[data-fav-root]');
    if (!wurzel) return;

    var gitter = wurzel.querySelector('[data-fav-gitter]');
    var leer = wurzel.querySelector('[data-fav-leer]');
    var zeile = wurzel.querySelector('[data-fav-zeile]');
    var geteilt = geteilteListe();
    var liste = geteilt || Fav.read();

    /* is-geteilt bleibt - daran haengt, dass ein Herzklick in der
       geteilten Ansicht die Liste eines anderen nicht aufraeumt.
       Nur das Band dazu ist weg. */
    wurzel.classList.toggle('is-geteilt', !!geteilt);
    zeigen(wurzel.querySelector('[data-fav-teilen]'), !geteilt && liste.length > 0);

    zeile.textContent = liste.length ? favZaehlText(liste.length) : '';
    if (!liste.length) { gitter.hidden = true; leer.hidden = false; gitter.innerHTML = ''; return; }

    leer.hidden = true;
    gitter.hidden = false;
    gitter.innerHTML = liste.map(function () { return '<div class="mp-favs__warten"></div>'; }).join('');

    var basis = routes.rootUrlWithoutSlash || '';
    Promise.all(liste.map(function (h) {
      return fetch(basis + '/products/' + encodeURIComponent(h) + '?section_id=mp-fav-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (teile) {
      var hof = document.createElement('div');
      teile.forEach(function (t) {
        if (!t) return;
        var dd = document.createElement('div');
        dd.innerHTML = t;
        var z = dd.querySelector('.mp-favs__zelle');
        if (z) hof.appendChild(z);
      });
      gitter.innerHTML = hof.innerHTML;
      favLeerPruefen(wurzel);
      favSync();
      galerienSetzen();
    });
  }

  /* ------------------------------------------------------------
     Link kopieren.

     Vorher rief das hier auf dem Telefon navigator.share auf. Das
     ist gut gemeint und an dieser Stelle falsch: Es oeffnet das
     Systemfenster mit zwanzig Zielen, und wer nur den Link in die
     Zwischenablage wollte, muss sich dort erst noch fuer eines
     entscheiden. Ein Knopf, eine Wirkung - also kopieren, auf
     jedem Geraet gleich.

     Drei Wege, in dieser Reihenfolge:
       1. navigator.clipboard - der richtige Weg. Braucht einen
          sicheren Kontext; https und 127.0.0.1 sind sicher, ein
          http-Host im Netz nicht.
       2. execCommand('copy') ueber ein Feld, das niemand sieht.
          Veraltet, aber es funktioniert genau dort, wo (1) nicht
          darf - und es kopiert wirklich, statt nur zu behaupten.
       3. Erst wenn beides scheitert, das Linkfeld zum Markieren.
          Dann hat der Mensch den Link immer noch, nur mit einem
          Handgriff mehr.

     Bestaetigt wird im Knopf selbst, nicht in einer Meldung
     daneben: Die Antwort gehoert an den Ort der Frage. Getauscht
     wird dabei NUR der Text im Label-Span und die Klasse - nicht
     der Inhalt des Knopfes. Das war vorher ein echter Fehler:
     b.textContent = text loescht das SVG mit, und beim
     Zuruecksetzen kam es nicht wieder, weil in data-alt nur der
     Text stand. Nach dem ersten Klick war das Zeichen fuer immer
     weg.
     ------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fav-teilen]');
    if (!b) return;
    e.preventDefault();
    var url = teilenLink();
    if (!url) return;

    function bestaetigen() {
      var label = b.querySelector('[data-fav-teilen-label]');
      b.classList.add('is-kopiert');
      if (label) {
        if (!b.getAttribute('data-alt')) b.setAttribute('data-alt', label.textContent);
        label.textContent = b.getAttribute('data-kopiert') || 'Link kopiert';
      }
      clearTimeout(b._zurueck);
      b._zurueck = setTimeout(function () {
        b.classList.remove('is-kopiert');
        if (label) label.textContent = b.getAttribute('data-alt') || label.textContent;
      }, 2200);
    }

    /* Der alte Weg. Das Feld muss im Dokument stehen und
       auswaehlbar sein - display:none oder visibility:hidden
       verhindern die Auswahl, deshalb 1x1 px bei opacity 0. */
    function altKopieren() {
      try {
        var f = document.createElement('textarea');
        f.value = url;
        f.setAttribute('readonly', '');
        f.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;pointer-events:none';
        document.body.appendChild(f);
        f.select();
        if (f.setSelectionRange) f.setSelectionRange(0, url.length);
        var ok = document.execCommand('copy');
        f.parentNode.removeChild(f);
        return ok;
      } catch (err) {
        return false;
      }
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
        .then(bestaetigen)
        .catch(function () {
          if (altKopieren()) { bestaetigen(); } else { linkZeigen(b, url); }
        });
      return;
    }
    if (altKopieren()) { bestaetigen(); return; }
    linkZeigen(b, url);
  });

  function linkZeigen(b, url) {
    var feld = document.querySelector('[data-fav-linkfeld]');
    if (!feld) return;
    feld.value = url;
    feld.removeAttribute('hidden');
    feld.focus();
    feld.select();
  }

  /* Das Uebernehmen der ganzen geteilten Liste ist entfallen -
     mit dem Balken, in dem der Knopf sass. Wer eine geteilte Liste
     ansieht, merkt sich einzelne Produkte ueber ihr Herz; der
     mp:favs-Zweig weiter unten laesst die geteilte Ansicht dabei
     ausdruecklich stehen. Begruendung steht in
     sections/mp-favoriten.liquid. */

  document.documentElement.addEventListener('mp:favs', function (e) {
    var wurzel = document.querySelector('[data-fav-root]');
    if (!wurzel) return;

    /* In der geteilten Ansicht bleibt die Liste stehen. Wer dort ein
       Herz antippt, merkt sich das Produkt - er raeumt nicht die
       Liste eines anderen auf. */
    if (wurzel.classList.contains('is-geteilt')) return;

    var liste = (e.detail && e.detail.list) || Fav.read();
    var gitter = wurzel.querySelector('[data-fav-gitter]');
    wurzel.querySelector('[data-fav-zeile]').textContent = liste.length ? favZaehlText(liste.length) : '';
    zeigen(wurzel.querySelector('[data-fav-teilen]'), liste.length > 0);

    var vorhanden = [];
    Array.prototype.forEach.call(gitter.querySelectorAll('.mp-favs__zelle'), function (z) {
      var h = z.getAttribute('data-handle');
      vorhanden.push(h);
      if (liste.indexOf(h) === -1) {
        z.classList.add('is-weg');
        setTimeout(function () { z.remove(); favLeerPruefen(wurzel); }, 260);
      }
    });

    if (liste.filter(function (h) { return vorhanden.indexOf(h) === -1; }).length) favSeite();
  });

  /* =========================================================
     Start und Nachzuegler
     ========================================================= */
  function start() { favSync(); favSeite(); galerienSetzen(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  var warte = null;
  new MutationObserver(function () {
    clearTimeout(warte);
    warte = setTimeout(favSync, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===========================================================
   Akkordeon: weich auf und zu

   <details>/<summary> bringt Bedienung, Tastatur und Ansage fuer
   Screenreader mit - deshalb steht es weiter da. Was der Browser
   nicht mitbringt, ist eine Bewegung: Er schaltet den Inhalt in
   einem Bild von "nicht da" auf "da". Bei einer Produktbeschreibung
   von zehn Zeilen springt damit die halbe Seite.

   Hier wird deshalb NUR das Umschalten selbst uebernommen: Beim
   Aufklappen faehrt die Hoehe von 0 auf ihren Wert, beim Zuklappen
   zurueck - und erst danach schliesst das Element wirklich. Ohne
   dieses "erst danach" waere der Inhalt beim ersten Bild weg und
   die Animation liefe ins Leere.

   Wer weniger Bewegung eingestellt hat, bekommt das Verhalten von
   vorher: sofort, ohne Umweg.
   =========================================================== */
(function () {
  var DAUER = 260;
  var EASE = 'cubic-bezier(.23,1,.32,1)';   /* dieselbe Kurve wie --mp-ease */

  function ruhig() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function kannAnimieren(el) {
    return typeof el.animate === 'function';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var kopf = e.target.closest('.mp-akk__kopf');
    if (!kopf) return;

    var det = kopf.parentElement;
    if (!det || det.tagName !== 'DETAILS') return;

    var inhalt = det.querySelector('.mp-akk__inhalt');
    if (!inhalt || ruhig() || !kannAnimieren(inhalt)) return;   /* Browser macht es selbst */

    e.preventDefault();
    schalte(det, inhalt);
  });

  function schalte(det, inhalt) {
    /* Laufendes abbrechen und von der AKTUELLEN Hoehe aus neu
       ansetzen - sonst springt es bei schnellen Klicks. */
    if (det._mpAkkAnim) {
      det._mpAkkAnim.cancel();
      det._mpAkkAnim = null;
      det._mpAkkLief = true;
    }

    /* Woher die Bewegung startet.

       NICHT einfach die gemessene Hoehe: Ein geschlossenes <details>
       laesst seinen Inhalt in neueren Browsern weiter im Layout
       stehen (die Hoehe wird ueber ::details-content ausgeblendet,
       nicht ueber display:none). Gemessen kamen deshalb auch im
       zugeklappten Zustand 482 px heraus - die Bewegung waere von
       482 nach 482 gelaufen, also gar nicht.

       Richtig ist: zugeklappt faengt bei Null an, aufgeklappt bei
       dem, was gerade dasteht - und bei einem Klick mitten in der
       Bewegung bei genau der Hoehe dieses Augenblicks. */
    var laeuft = !!det._mpAkkLief;
    var auf = !det.open;
    var von = (auf && !laeuft) ? 0 : inhalt.getBoundingClientRect().height;

    if (auf) {
      det.open = true;
      det.classList.remove('mp-akk--schliesst');
    } else {
      /* Der Pfeil dreht sich sofort zurueck, obwohl das Element noch
         offen ist - sonst kippt er erst, wenn alles schon zu ist. */
      det.classList.add('mp-akk--schliesst');
    }

    var bis = auf ? inhalt.scrollHeight : 0;

    /* Das Polster muss mitfahren.

       Der Inhalt hat unten 16 px Polster. Polster laesst sich nicht
       zusammendruecken: Bei height:0 bleibt der Kasten trotzdem
       16 px hoch. Genau das war der Rest, der nach dem Zuklappen
       einen Wimpernschlag lang stehenblieb und erst verschwand,
       wenn das <details> wirklich zuging.

       Also faehrt beides mit - Hoehe UND Polster -, beim Aufklappen
       zurueck auf den Wert aus dem Stylesheet. Ausgelesen statt fest
       eingetragen, damit eine spaetere Aenderung am Polster hier
       nichts kaputt macht; gemerkt wird er am Element, weil er
       waehrend der Bewegung selbst auf Null steht. */
    var stil = window.getComputedStyle(inhalt);
    if (!det._mpAkkPolster && parseFloat(stil.paddingBottom) > 0) {
      det._mpAkkPolster = [stil.paddingTop, stil.paddingBottom];
    }
    var polster = det._mpAkkPolster || ['0px', '0px'];

    inhalt.style.overflow = 'hidden';
    var a = inhalt.animate(
      [
        {
          height: von + 'px',
          paddingTop:    auf ? '0px' : polster[0],
          paddingBottom: auf ? '0px' : polster[1],
          opacity: auf ? 0 : 1
        },
        {
          height: bis + 'px',
          paddingTop:    auf ? polster[0] : '0px',
          paddingBottom: auf ? polster[1] : '0px',
          opacity: auf ? 1 : 0
        }
      ],
      { duration: DAUER, easing: EASE }
    );
    det._mpAkkAnim = a;
    det._mpAkkLief = true;

    /* Ueber das Versprechen, nicht ueber onfinish.

       Das finish-EREIGNIS wird im Zeichentakt zugestellt - und der
       steht still, solange der Tab im Hintergrund liegt. Wer eine
       Zeile aufklappt, den Tab wechselt und zurueckkommt, haette
       sonst ein Akkordeon, das fuer immer halb offen ist. Das
       Versprechen loest auch dann aus. Nachgemessen genau so:
       onfinish blieb stumm, a.finished kam an. */
    a.finished.then(function () {
      inhalt.style.overflow = '';
      det._mpAkkAnim = null;
      det._mpAkkLief = false;
      if (!auf) {
        det.open = false;
        det.classList.remove('mp-akk--schliesst');
      }
    }, function () {
      /* Abgebrochen, weil jemand nochmal geklickt hat. Die neue
         Bewegung raeumt auf, hier bleibt nur das Polster. */
      inhalt.style.overflow = 'hidden';
    });
  }
})();
